
const newModel = () => {
    return {
        nganHangId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        nganHangId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        nganHangId: item.nganHangId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        nganHangId: item.nganHangId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        diaChi: item.diaChi,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        nganHangId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        diaChi: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const nganHangModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


